import React, { useEffect } from 'react';

import { Row } from 'apps/auth/components/common/Layout/Row';
import { SpinnerLottie } from 'apps/auth/components/common/SpinnerLottie/SpinnerLottie';
import { Text } from 'apps/auth/components/common/Text/Text';
import { useApp, usePageMessages } from 'apps/auth/hooks/selectors';
import clsx from 'clsx';

import styles from './Spinner.module.css';

interface SpinnerProps {
    forceShow?: boolean;
    insidePopup?: boolean;
    isEmptyText?: boolean;
    customSpinnerText?: string;
}

const Spinner: React.FC<SpinnerProps> = ({ forceShow = false, insidePopup, isEmptyText, customSpinnerText }) => {
    const app = useApp<{ isShowSpinner?: boolean; isMobileBrowser?: boolean }>();
    const pageMessages = usePageMessages<{ siteSpinnerText?: string }>();
    const isVisible = Boolean(app?.isShowSpinner) || forceShow;

    useEffect(() => {
        if (isVisible && app?.isMobileBrowser) {
            const focusedElement = document.activeElement;
            if (focusedElement instanceof HTMLInputElement) {
                setTimeout(() => {
                    focusedElement.blur();
                }, 1000);
            }
        }
    }, [isVisible]);

    if (!isVisible) {
        return null;
    }

    return (
        <div className={clsx(styles.spinnerOverlay, insidePopup && styles.spinnerOverlayInsidePopup)}>
            <div className={styles.spinnerContainer}>
                <Row indent={isEmptyText ? '0' : '24px'}>
                    <SpinnerLottie />
                </Row>
                {!isEmptyText && <Text variant="paragraph">{customSpinnerText || pageMessages?.siteSpinnerText}</Text>}
            </div>
        </div>
    );
};

export default Spinner;
